import type { SystemSettingsResponse, UpdateSystemSettingsDto } from '../services/api';

export type SystemSettings = SystemSettingsResponse;
export type UpdateSystemSettingsPayload = UpdateSystemSettingsDto;

export interface SystemSettingsFormState {
  logoUrl: string;
  primaryColor: string;
  secondaryColor: string;
  footerText: string;
}

export type SystemSettingsField = keyof SystemSettingsFormState;

export const FOOTER_MAX_LENGTH = 500;
export const FOOTER_WARNING_THRESHOLD = 450;

export const DEFAULT_PRIMARY_COLOR = '#0F172A';
export const DEFAULT_SECONDARY_COLOR = '#3B82F6';

export const SYSTEM_SETTINGS_FORM_DEFAULTS: SystemSettingsFormState = {
  logoUrl: '',
  primaryColor: DEFAULT_PRIMARY_COLOR,
  secondaryColor: DEFAULT_SECONDARY_COLOR,
  footerText: '',
};

export const HEX_COLOR_REGEX = /^#(?:[0-9A-F]{3}){1,2}$/i;

export const URL_PROTOCOL_WHITELIST = ['http:', 'https:'];

export const SYSTEM_SETTINGS_QUERY_KEY = ['admin', 'system-settings'] as const;
